import React from 'react';
import Accessibility from '../defaults/Accessibility';

export default (props) => {
  return (
    <Accessibility />
  );
}
